<div class="c-help">
	@if (show()) {
		<div class="c-help-container c-help-container--show">
			<div class="c-help-container__title">
				<p class="u-title-sub flex--1">{{ 'HELP.TITLE' | translate }}</p>

				<button (click)="show.set(false)">
					<tvcore-icon name="close"></tvcore-icon>
				</button>
			</div>

			<p class="u-text--medium">{{ 'HELP.DESCRIPTION' | translate }}</p>

			<div class="c-help-container__item">
				<tvcore-icon name="building"></tvcore-icon>

				<div>
					<p class="u-text--medium">{{ 'HELP.RAP' | translate }}</p>
					<a href="https://www.iedereenverdientvakantie.be/nl/rap-op-stap" target="_blank">
						{{ 'HELP.RAP_SUB' | translate }}
						<tvcore-icon name="external-link"></tvcore-icon>
					</a>
				</div>
			</div>

			<div class="c-help-container__item">
				<tvcore-icon name="phone"></tvcore-icon>

				<div>
					<p class="u-text--medium">Telefonisch</p>
					<p><a href="tel:025040391">02 504 03 91</a> (elke werkdag van 9 tot 19 uur)</p>
				</div>
			</div>

			<div class="c-help-container__item">
				<tvcore-icon name="mail"></tvcore-icon>

				<div>
					<p class="u-text--medium">{{ 'HELP.EMAIL' | translate }}</p>
					<a href="mailto:info@iedereenverdientvakantie.be" target="_blank">info&#64;iedereenverdientvakantie.be</a>
				</div>
			</div>

			<div class="c-help-container__item">
				<tvcore-icon name="question-circle"></tvcore-icon>

				<div>
					<p class="u-text--medium">{{ 'HELP.FAQ' | translate }}</p>
					<a href="https://www.iedereenverdientvakantie.be/nl/veelgestelde-vragen" target="_blank">
						{{ 'HELP.FAQ_SUB' | translate }}
						<tvcore-icon name="external-link"></tvcore-icon>
					</a>
				</div>
			</div>

			<div class="c-help-container__item">
				<tvcore-icon name="question-circle"></tvcore-icon>

				<div>
					<p class="u-text--medium">{{ 'HELP.DIGI' | translate }}</p>
					<a href="https://digibanken.vlaanderen.be/" target="_blank">
						{{ 'HELP.DIGI_SUB' | translate }}
						<tvcore-icon name="external-link"></tvcore-icon>
					</a>
				</div>
			</div>
		</div>
	}

	<button (click)="toggle()" class="c-help__button">
		<span>{{ 'HELP.TITLE' | translate }}</span>
		<tvcore-icon name="help"></tvcore-icon>
	</button>
</div>
